import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { Modal, DeleteModal } from "../../Modal";
import { CSVLink } from "react-csv";
import exportPDF from "../../../utils/exportPDF";
import NeNewTestHistoryAccount from "./NewTest";
import { defineRole } from "../../../utils/handleAccessRoles";
import { getStorage } from "../../../utils/storage";
import icons from "../../../constants/icons";
import { ROLE_BLOOD_TEST_BLOOD_GROUPING } from "../../../constants/ROLES";
import {
  fetchBloodTestHistory,
  deleteBloodTestHistory,
} from "../../../utils/queries/bloodTestHistory";
import accessMenu from "../../../utils/accessMenu";
import { renderDuBloodGroup } from "../../../utils/bloodGroupInfo";
// eslint-disable-next-line no-unused-vars

// eslint-disable-next-line no-unused-vars
let copyData = [];

// eslint-disable-next-line no-unused-vars
class BloodGrouping extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    totalPageCount: 10,
    delete_password: "",
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({ error, [field]: e?.target?.value });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { canConfirmBloodTestBloodGrouping } = accessMenu();

      const { page, limit } = this.state;
      const { defaultLanguage, testId } = this.props;

      this.setState({
        isLoading,
        canConfirm: canConfirmBloodTestBloodGrouping,
      });

      const { data, count, totalRecords } = await fetchBloodTestHistory(defaultLanguage, {
        page,
        limit,
        bloodTest: testId,
        questionnaireType: "bloodGrouping",
        // testBy: !canConfirmBloodTestBloodGrouping ? user.id : undefined,
        ...search,
      });

      this.setState(
        {
          data,
          totalPageCount: count,
        totalRecords,
          isLoading: false,
        },
        () => {
          this.handleCountAddEnableAdd();
        }
      );

      copyData = data.slice(0);
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}, questionnaireIndex) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
      questionnaireIndex,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    const { canConfirmBloodTestBloodGrouping } = accessMenu();

    let headers = [
      {
        title: language[this.props.defaultLanguage].code,
        key: "code",
        type: canConfirmBloodTestBloodGrouping && "link",
        onPress: (item, index) =>
          canConfirmBloodTestBloodGrouping
            ? this.handleShowModal("showModal", "NO:" + item.code, item, index)
            : null,
        styles: {
          textTransform: "uppercase",
        },
      },
      canConfirmBloodTestBloodGrouping && {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodGroup",
        render: (item) => renderDuBloodGroup(item.bloodGroup),
      },
      {
        title: language[this.props.defaultLanguage].tested_by,
        key: "testBy.name",
        fallbackKeys: ["operator.name", "operator.type"],
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        formatTime: "lll",
        isMoment: true,
      },
      this.state.canConfirm && {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ].filter(Boolean);

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteBloodTestHistory(this.props.defaultLanguage, {
        id: this.state.selectedData._id,
        bloodTest:
          this.state.selectedData.bloodTest?._id ||
          this.state.selectedData.bloodTest,
      });

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      const { data } = await fetchBloodTestHistory(defaultLanguage, {
        page,
        limit,
        bloodTest: this.props.testId,
        questionnaireType: "bloodGrouping",
      });

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async () => {
    this.setState({
      isLoading: true,
    });

    const { page, limit } = this.state;
    const { defaultLanguage } = this.props;

    const headers = this.returnTableHeaders();

    const { data } = await fetchBloodTestHistory(defaultLanguage, {
      page,
      limit,
      bloodTest: this.props.testId,
      questionnaireType: "bloodGrouping",
    });

    this.setState({
      isLoading: false,
    });

    exportPDF("Blood Grouping", headers, data);
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      code: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleCountAddEnableAdd = () => {
    const { data, user } = this.state;

    let count = 0,
      total = 0,
      isEnabledAdd = false;

    for (let el of data) {
      if (el.status !== "cancelled") {
        if (el?.testBy?._id === user.id) {
          count += 1;
        }

        total += 1;
      }
    }

    if (count > 0 || total === 2) {
      isEnabledAdd = false;
    } else {
      isEnabledAdd = total < 2;
    }

    if (data.length > 0 && data[0]?.bloodTest?.donation?.listOfSamples) {
      const samples = (data[0]?.bloodTest?.donation?.listOfSamples || []).map(
        (el) => el.value
      );

      if (
        samples?.includes("SN_FOR_BLOOD_GROUPING") &&
        total < 3 &&
        !isEnabledAdd
      ) {
        isEnabledAdd = true;
      }
    }

    this.setState({
      isEnabledAdd,
    });
  };

  render() {
    const { export_, edit, delete_ } = language[this.props.defaultLanguage];

    const canAccessCreateBloodTest_grouping = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_BLOOD_TEST_BLOOD_GROUPING,
      operation: "create",
    });

    return (
      <>
        {this.state?.data?.[0]?.bloodTest?.donation?.status === "product_restricted" ? (
          <div className="alert alert-warning">
            <h3>{language[this.props.defaultLanguage].product_restricted_donation}</h3>
            <p>
              <strong>{language[this.props.defaultLanguage].reason}:</strong>{" "}
              {this.state?.data[0]?.bloodTest?.donation?.blockInfo?.blockReason}
            </p>
            <p>{language[this.props.defaultLanguage].product_restricted_donation_info}</p>
          </div>
        ) : this.state?.data?.[0]?.bloodTest?.donation?.blockInfo?.blocked && (
          <div className="alert alert-danger">
            <h3>{language[this.props.defaultLanguage].blocked_donation}</h3>
            <p>
              {language[this.props.defaultLanguage].reason}:{" "}
              {this.state?.data[0]?.bloodTest?.donation?.blockInfo?.blockReason}
            </p>
          </div>
        )}
        <Table
          data={this.state.data}
          isSearch={false}
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          showAdd={this.state.isEnabledAdd && canAccessCreateBloodTest_grouping}
          addButtonText={language[this.props.defaultLanguage].add}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].add
          )}
          rowPress={(item, index) =>
            this.state.canConfirm
              ? this.handleShowModal("showModal", item.name, item, index)
              : null
          }
          filters={[
            {
              type: "export",
              title: export_,
              button_type: "dropdown",
              icon: "bx bxs-download",
              options: [
                {
                  name: "PDF",
                  onPress: this.downloadPDF.bind(this),
                },
                {
                  name: "CSV",
                  onPress: this.downloadExcel.bind(this),
                },
              ],
            },
          ]}
          actions={[
            {
              canAccess:
                this.state.canConfirm &&
                defineRole({
                  roles: this.state.user.accessRole,
                  menu: ROLE_BLOOD_TEST_BLOOD_GROUPING,
                  operation: "update",
                }),
              icon: icons.edit,
              name: edit,
              onPress: (item, index) =>
                this.handleShowModal(
                  "showModal",
                  language[this.props.defaultLanguage].edit,
                  item,
                  index
                ),
            },
            {
              canAccess:
                this.state.canConfirm &&
                defineRole({
                  roles: this.state.user.accessRole,
                  menu: ROLE_BLOOD_TEST_BLOOD_GROUPING,
                  operation: "delete",
                }),
              icon: icons.delete,
              name: delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                language[this.props.defaultLanguage].delete_
              ),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <NeNewTestHistoryAccount
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selectedData}
            testId={this.props.testId}
            canConfirm={this.state.data.length >= 1}
            previousTestResults={
              !this.state?.selectedData?._id ? this.state.data : []
            }
            questionnaireIndex={this.state.questionnaireIndex}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"BloodGrouping" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(BloodGrouping);
